import { render, staticRenderFns } from "./EditBulkRecords.vue?vue&type=template&id=5b9630a5&"
import script from "./EditBulkRecords.vue?vue&type=script&lang=js&"
export * from "./EditBulkRecords.vue?vue&type=script&lang=js&"
import style0 from "./EditBulkRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports